import {
  avatar,
  background,
  captions,
  host,
  rule,
  speaker,
  text,
  visualizer,
} from './helpers'
import type { TemplateBlueprint } from './types'

/**
 * `ScriptLargeLayout` (`layouts/ScriptLargeLayout.tsx`): a big speaker
 * header (name over handle at half opacity), captions, a rule, the episode,
 * and tall square bars rising from the foot. One line each. Intended
 * differences: v1 painted the bars over the footer text; here the text
 * stays on top.
 */
const bars = { variant: 'blocks' as const }
const episode = { size: 40, weight: 400, lineHeight: 1.475 }

export const scriptLargeBlueprint: TemplateBlueprint = {
  kind: 'audio',
  orientations: {
    portrait: [
      background(),
      avatar('portrait', 60, 60, 234),
      speaker(
        'portrait',
        [358, 84, 660, 96],
        'name',
        { size: 60, weight: 400, lineHeight: 1.6 },
        { color: 'speakerName' },
      ),
      speaker('portrait', [358, 180, 660, 89], 'handle', {
        size: 56,
        weight: 400,
        lineHeight: 1.6,
        opacity: 0.5,
      }),
      captions('portrait', [60, 354, 960, 755], 'start'),
      rule('portrait', 'divider', [60, 1189, 960, 2], 'border'),
      host('portrait', 60, 1271, 116),
      text('portrait', 'title', [216, 1271, 804, 59], episode),
      text('portrait', 'subtitle', [216, 1330, 804, 59], episode),
      visualizer('portrait', [0, 1320, 1080, 600], bars),
    ],
    square: [
      background(),
      avatar('square', 60, 60, 206),
      speaker(
        'square',
        [330, 70, 690, 96],
        'name',
        { size: 60, weight: 400, lineHeight: 1.6 },
        { color: 'speakerName' },
      ),
      speaker('square', [330, 166, 690, 89], 'handle', {
        size: 56,
        weight: 400,
        lineHeight: 1.6,
        opacity: 0.5,
      }),
      captions('square', [60, 314, 960, 243], 'start'),
      rule('square', 'divider', [60, 607, 960, 2], 'border'),
      host('square', 60, 659, 116),
      text('square', 'title', [216, 659, 804, 59], episode),
      text('square', 'subtitle', [216, 718, 804, 59], episode),
      visualizer('square', [0, 780, 1080, 300], bars),
    ],
    landscape: [
      background(),
      avatar('landscape', 90, 90, 234),
      speaker(
        'landscape',
        [90, 384, 585, 102],
        'name',
        { size: 60, weight: 400, lineHeight: 1.7 },
        { color: 'speakerName' },
      ),
      speaker('landscape', [90, 486, 585, 95], 'handle', {
        size: 56,
        weight: 400,
        lineHeight: 1.7,
        opacity: 0.5,
      }),
      captions('landscape', [675, 90, 1155, 384], 'start'),
      rule('landscape', 'divider', [675, 534, 1155, 2], 'border'),
      host('landscape', 675, 596, 116),
      text('landscape', 'title', [851, 596, 979, 59], episode),
      text('landscape', 'subtitle', [851, 655, 979, 59], episode),
      visualizer('landscape', [0, 680, 1920, 400], bars),
    ],
  },
}
